import React, { useRef } from "react";

import Hero from "../../components/User/Career/Hero";

import OpenPositions from "../../components/User/Career/OpenPositions";
import CTA from "../../components/User/Career/CTA";
import ChooseUs from "./home/ChooseUs";

const Career = () => {

 const openPositionsRef = useRef(null);

  const scrollToOpenPositions = () => {
    openPositionsRef.current?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };

  return (
    <>
     <Hero scrollToOpenPositions={scrollToOpenPositions} />

      <div ref={openPositionsRef}  className="scroll-mt-28">
        <OpenPositions />
      </div>

      <ChooseUs />
      <CTA />
    </>
  );
};

export default Career;